// Text FX — vanilla ports of React Bits text animations, applied sparingly:
//   gradient-text   → homepage .hero-claim
//   scroll-float    → .epos .sect-head h2, .collezioni .sect-head h2
//   scrambled-text  → .authenticity .sect-head h2
//   rotating-text   → .foot-tag (the two approved tagline strings)
//   scroll-velocity → #marqueeTrack (modulates its existing CSS animation's
//                     playbackRate by scroll velocity — no markup change)
//   text-pressure   → .maison h2 (Roboto Flex wght/wdth by cursor proximity)
//   variable-proximity → .loved .sect-head h2 (wght only, gaussian falloff)
// glass-surface is CSS-only (.glass-mz on .nl-form) — the source component
// explicitly falls back to a frosted panel on Firefox/Safari.
(function () {
  function chars(el) {
    // words wrapped in nowrap spans so inline-block chars never break mid-word;
    // the original text stays readable to assistive tech via aria-label
    el.setAttribute('aria-label', el.textContent);
    var words = el.textContent.split(' ');
    el.textContent = '';
    var out = [];
    words.forEach(function (word, wi) {
      var w = document.createElement('span');
      w.className = 'tfx-word';
      w.setAttribute('aria-hidden', 'true');
      for (var i = 0; i < word.length; i++) {
        var s = document.createElement('span');
        s.className = 'tfx-char';
        s.textContent = word[i];
        s.dataset.content = word[i];
        w.appendChild(s);
        out.push(s);
      }
      el.appendChild(w);
      if (wi < words.length - 1) el.appendChild(document.createTextNode(' '));
    });
    return out;
  }
  function clamp01(v) { return Math.min(Math.max(v, 0), 1); }

  // ── gradient-text ──
  var gt = document.querySelector('.home .hero-claim');
  if (gt) gt.classList.add('tfx-gradient');

  // ── glass surface ──
  Array.prototype.forEach.call(document.querySelectorAll('.nl-form'), function (f) {
    f.classList.add('glass-mz');
  });

  // ── scroll-float (scrub: chars rise/unsquash between viewport marks) ──
  var floats = [];
  Array.prototype.forEach.call(
    document.querySelectorAll('.epos:not(.epos-dark) .sect-head h2, .collezioni .sect-head h2, .tfx-float'),
    function (h) { floats.push({ el: h, chars: chars(h) }); }
  );
  function backOut(x) { var c = 1.70158; return 1 + (c + 1) * Math.pow(x - 1, 3) + c * Math.pow(x - 1, 2); }
  function floatTick() {
    var vh = innerHeight;
    floats.forEach(function (f) {
      var r = f.el.getBoundingClientRect();
      var start = vh * 1.5, end = vh * 0.6;
      var p = clamp01((start - (r.top + r.height / 2)) / (start - end));
      var n = f.chars.length;
      f.chars.forEach(function (c, i) {
        var sp = (i / Math.max(n - 1, 1)) * 0.4;
        var e = backOut(clamp01((p - sp) / 0.6));
        c.style.opacity = clamp01(e).toFixed(3);
        c.style.transform = 'translateY(' + (120 * (1 - e)).toFixed(1) + '%) scale(' +
          (0.7 + 0.3 * e).toFixed(3) + ',' + (2.3 - 1.3 * e).toFixed(3) + ')';
      });
    });
  }
  if (floats.length) {
    addEventListener('scroll', floatTick, { passive: true });
    floatTick();
  }

  // ── scrambled-text (pointer-radius char scramble) ──
  Array.prototype.forEach.call(document.querySelectorAll('.authenticity .sect-head h2'), function (h) {
    var cs = chars(h);
    var RADIUS = 100, CHARS = '.:';
    cs.forEach(function (c) { c._t = null; });
    h.addEventListener('pointermove', function (e) {
      cs.forEach(function (c) {
        if (c._t) return;
        var r = c.getBoundingClientRect();
        var d = Math.hypot(e.clientX - (r.left + r.width / 2), e.clientY - (r.top + r.height / 2));
        if (d >= RADIUS) return;
        var dur = 1200 * (1 - d / RADIUS);
        var t0 = performance.now();
        c._t = setInterval(function () {
          if (performance.now() - t0 > dur) {
            clearInterval(c._t); c._t = null;
            c.textContent = c.dataset.content;
          } else {
            c.textContent = CHARS[Math.floor(Math.random() * CHARS.length)];
          }
        }, 40);
      });
    });
  });

  // ── rotating-text (footer tagline) ──
  Array.prototype.forEach.call(document.querySelectorAll('.foot-tag'), function (tag) {
    var TEXTS = ["l'arte dell'Essere", 'the art of being.'];
    var idx = 0;
    tag.classList.add('tfx-rotate');
    function show(text) {
      tag.textContent = '';
      var spans = [];
      for (var i = 0; i < text.length; i++) {
        var s = document.createElement('span');
        s.className = 'tfx-char tfx-rin';
        s.style.transitionDelay = (i * 0.025) + 's';
        s.textContent = text[i] === ' ' ? ' ' : text[i];
        tag.appendChild(s);
        spans.push(s);
      }
      void tag.offsetWidth;
      spans.forEach(function (s) { s.classList.remove('tfx-rin'); });
    }
    show(TEXTS[0]);
    setInterval(function () {
      var spans = tag.querySelectorAll('.tfx-char');
      Array.prototype.forEach.call(spans, function (s, i) {
        s.style.transitionDelay = (i * 0.02) + 's';
        s.classList.add('tfx-rout');
      });
      setTimeout(function () { idx = (idx + 1) % TEXTS.length; show(TEXTS[idx]); }, 450);
    }, 3200);
  });

  // ── endless marquee ── the CSS keyframe slides the track by -50%, so the track must be two identical halves, each at least a
  // screen wide. The markup carries the lines once; clone them here. Duration follows the width, so the speed (~25px/s, what the
  // single-copy strip ran at) is the same on a phone and on a 2000px monitor.
  (function () {
    var track = document.getElementById('marqueeTrack');
    if (!track || !track.children.length) return;
    var set = [].slice.call(track.children), one = track.scrollWidth;
    if (!one) return;
    var reps = Math.ceil((Math.max(innerWidth, screen.width || 0) + 64) / one);   // copies per half
    var frag = document.createDocumentFragment();
    for (var r = 1; r < reps * 2; r++) set.forEach(function (n) { frag.appendChild(n.cloneNode(true)); });
    track.appendChild(frag);
    track.style.setProperty('--mq-dur', (one * reps / 25).toFixed(1) + 's');
  })();

  // ── scroll-velocity (marquee playbackRate follows scroll velocity) ──
  (function () {
    var track = document.getElementById('marqueeTrack');
    if (!track || !track.getAnimations) return;
    var lastY = scrollY, vel = 0, sm = 0;
    addEventListener('scroll', function () {
      vel = scrollY - lastY; lastY = scrollY;
    }, { passive: true });
    (function tick() {
      requestAnimationFrame(tick);
      sm += (vel - sm) * 0.12; vel *= 0.8;
      var anims = track.getAnimations();
      if (anims.length) {
        var rate = 1 + Math.min(Math.abs(sm) * 0.12, 4);
        if (sm < -0.5) rate = -rate;
        anims[0].playbackRate = rate;
      }
    })();
  })();

  // ── text-pressure (maison h2 — Roboto Flex wght/wdth pressure) ──
  var pressureEls = [];
  Array.prototype.forEach.call(document.querySelectorAll('.maison h2'), function (h) {
    h.classList.add('tfx-pressure');
    pressureEls.push({ el: h, chars: chars(h) });
  });

  // ── variable-proximity (loved h2 — wght only, gaussian) ──
  var proxEls = [];
  Array.prototype.forEach.call(document.querySelectorAll('.loved .sect-head h2'), function (h) {
    h.classList.add('tfx-vprox');
    proxEls.push({ el: h, chars: chars(h) });
  });

  if (pressureEls.length || proxEls.length) {
    var cur = { x: innerWidth / 2, y: 0 }, eased = { x: cur.x, y: cur.y };
    addEventListener('mousemove', function (e) { cur.x = e.clientX; cur.y = e.clientY; }, { passive: true });
    (function vfTick() {
      requestAnimationFrame(vfTick);
      eased.x += (cur.x - eased.x) / 15;
      eased.y += (cur.y - eased.y) / 15;
      pressureEls.forEach(function (p) {
        var tr = p.el.getBoundingClientRect();
        if (tr.bottom < -100 || tr.top > innerHeight + 100) return;
        var maxDist = tr.width / 2;
        p.chars.forEach(function (c) {
          var r = c.getBoundingClientRect();
          var d = Math.hypot(eased.x - (r.x + r.width / 2), eased.y - (r.y + r.height / 2));
          var wght = Math.floor(Math.max(100, 900 - Math.abs(900 * d / maxDist) + 100));
          var wdth = Math.floor(Math.max(35, 151 - Math.abs(151 * d / maxDist) + 35));
          var v = "'wght' " + wght + ", 'wdth' " + wdth;
          if (c.style.fontVariationSettings !== v) c.style.fontVariationSettings = v;
        });
      });
      proxEls.forEach(function (p) {
        var tr = p.el.getBoundingClientRect();
        if (tr.bottom < -100 || tr.top > innerHeight + 100) return;
        p.chars.forEach(function (c) {
          var r = c.getBoundingClientRect();
          var d = Math.hypot(cur.x - (r.x + r.width / 2), cur.y - (r.y + r.height / 2));
          var f = d >= 90 ? 0 : Math.exp(-Math.pow(d / 45, 2) / 2);
          var v = "'wght' " + Math.round(500 + 400 * f);
          if (c.style.fontVariationSettings !== v) c.style.fontVariationSettings = v;
        });
      });
    })();
  }
})();
